export default __webpack_public_path__ + "static/media/icon-delink.17be4858.svg";